<script lang="js" setup>
import HeaderView from './views/layout/HeaderView.vue';
import FooterView from './views/layout/FooterView.vue';



</script>

<template>

<HeaderView />
<router-view></router-view>
<FooterView />

</template>

<style scoped></style>